export default "/_next/static/images/210558f024453e2a1cebef812af19963.jpg";